import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { LoginDto } from 'src/app/models/LoginDto';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MessageCenterService } from 'src/app/services/message-center.service';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';
import { environment } from 'src/environments/environment';
import { LoggedOutLayoutComponent } from '../logged-out-layout/logged-out-layout.component';
import { ButtonModule } from 'primeng/button';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [
    SHARED_IMPORTS,
    LoggedOutLayoutComponent,
    RouterModule,
    ButtonModule,
    IconField,
    InputIcon
  ]
})
export class LoginComponent implements OnInit, OnDestroy {
  private formBuilder = inject(FormBuilder);
  private messageCenterService = inject(MessageCenterService);
  private translate = inject(TranslateService);
  private authService = inject(AuthService);
  private router = inject(Router);

  loginForm!: FormGroup;

  loginSubscription: Subscription = new Subscription();

  blockedAt?: Date;

  loginMethod = environment.loginMethod;

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', this.loginMethod === 'standard' ? Validators.required : '']
    });
  }

  ngOnDestroy(): void {
    this.loginSubscription.unsubscribe();
  }

  onSubmit() {
    if (this.loginMethod === 'standard') {
      if (this.loginForm && this.loginForm.valid) {
        const email = this.loginForm.get('email')?.value;
        const password = this.loginForm.get('password')?.value;
        const loginDto = new LoginDto(email, password);

        this.loginSubscription = this.authService.login(loginDto).subscribe({
          next: () => {
            this.authService.showLoginToast('success');
            this.router.navigate(['/']);
          },
          error: () => this.authService.showLoginToast('error')
        });
      } else {
        this.messageCenterService.showToast(
          this.translate.instant('loginComponent.toasts.error.summary'),
          this.translate.instant('loginComponent.toasts.error.detail'),
          'error'
        );
      }
    } else {
      this.useVerfication();
    }
  }

  useVerfication() {
    if (this.loginForm && this.loginForm.valid) {
      const email = this.loginForm.get('email')?.value;

      this.authService.generateCodeForLogin(email).subscribe((response) => {
        if (response) {
          const parameter = { email };
          this.router.navigate(['/verification'], { state: parameter });
        } else {
          this.messageCenterService.showToast(
            this.translate.instant('loginComponent.toasts.error.summary'),
            this.translate.instant('loginComponent.toasts.error.detail'),
            'error'
          );
          this.authService.getBlockedAtByEmail(email).subscribe((blockedAt) => {
            this.blockedAt = new Date(blockedAt);
          });
        }
      });
    }
  }
}
